import CustomerService from "../components/customor_service";
import DetailGizi from "../components/detail_gizi";
import Footer from "../components/footer";
import Navbar from "../components/navbar";

export default function DetailLayout() {
    return (
        <>
            <Navbar/>
            <DetailGizi/>
            <CustomerService/>
            <Footer/>
        </>
    );
}